
interface IQualityControlAction {
    type: string,
    payload?: boolean
}

function qualityControlReducer(state: boolean = false, action: IQualityControlAction): boolean {

    switch (action.type) {
        case "QUALITY_SET":
            return action.payload!;
        case "PROGRESS_CLEAR":
            return false;
        default:
            return state;
    }
}

export default qualityControlReducer;